<template>
	<div id="add__project__deliverable" class="deliverable-listing" :class="{hasFilter: (filterQuery.status.length || filterQuery.coordinator.length || filterQuery.tag.length || filterQuery.outlet.length)}">
		<b-modal centered hide-footer id="viewTitleModal" title="Enter View Title">
			<ViewTitleModal @setActiveView="setActiveView" ref="refViewTitleModal" />
		</b-modal>
		<b-modal centered hide-footer id="viewTitleUpdateModal" title="Enter View Title">
			<ViewTitleModal :title="viewBtnLabel" @setActiveView="setActiveView" :viewId="activeView" ref="refViewTitleModal" />
		</b-modal>
		<b-modal centered  hide-footer id="createContactModal" title="New Contact" @shown="focusContactModal">
			<CreateContactModal ref="refContactModal"/>
		</b-modal>

		<b-modal hide-footer id="editContactModal" title="Update Contact" @shown="focusUpdateContactModal">
			<UpdateContactModal  ref="refUpdateContactModal" />
		</b-modal>
		<b-modal v-model="showRemoveProjectDeli" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveProjectDeli" ok-title="Yes, Remove">
			<p>Are you sure you want to remove deliverable from this project?</p>
		</b-modal>

		<b-modal centered  hide-footer id="createSpokespersonModal" title="New Spokesperson" @shown="focusSpokespersonModal">
			<CreateSpokespersonModal ref="refSpokespersonModal"/>
		</b-modal>
		<b-modal centered  hide-footer id="createWhoModal" title="New Outlet / Contact" @shown="focusWhoModal">
			<CreateWhoModal ref="refWhoModal"/>
		</b-modal>

		<b-modal hide-footer id="editSpokespersonModal" title="Update Spokesperson" @shown="focusUpdateSpokespersonModal">
			<UpdateSpokespersonModal  ref="refUpdateSpokespersonModal" />
		</b-modal>
		<b-modal hide-footer id="editWhoModal" title="Update Outlet / Contact" @shown="focusUpdateWhoModal">
			<UpdateWhoModal  ref="refUpdateWhoModal" />
		</b-modal>

		<b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable" @hide="editDeliverableModalHidden" @shown="pushRoute" @hidden="removeRoute">
			<EditModal :allContacts="allContacts"  ref="refEditModal" :namespace="namespace" />
		</b-modal>
		<div>
			<!-- <div class="deliverable-header">
				<h2 class="d-inline-block">
					<div class="media-call-icon pointer-default">
						<img :src="require(`@/csmworkflow/img/${deliverableListIcon}.svg`)"/>
					</div>
					<span class="cursor-pointer" @click="$router.push('/project/' + $route.params.projectId)">{{ projectDetail.title }} <span class="text-muted">({{allDeliverablesPaginationData.total || 0}} deliverables, {{ outletCount || 0 }} calls)</span></span>
				</h2>
			</div> -->
			
			<div
				class="deliverable-block read-only"
				v-for="(deliverable, index) in deliverablesArray"
				v-if="index!='totalOutlets'"
				:key="'deliverable'+index"
			>
			<div class="overlay-info" :class="(deliverable.project_id == null || deliverable.project_id.id != $route.params.projectId) ? '' : 'active--overlay'">
				<div @click="deliverable.project_id == null || deliverable.project_id.id != $route.params.projectId ? addToProject(deliverable.id) : showRemoveProjectDeli=true; removingDeliverableId=deliverable.id" :title="deliverable.project_id == null || deliverable.project_id.id != $route.params.projectId ? 'Add to Project' : 'Remove from Project'" v-b-tooltip.hover class="link-deliverable-btn" :class="deliverable.project_id == null || deliverable.project_id.id != $route.params.projectId ? 'add-prj' : 'remove-prj'">
					{{ deliverable.project_id == null || deliverable.project_id.id != $route.params.projectId ? 'Add to Project' : 'Remove from Project' }}
					<div v-if="deliverable.project_id == null || deliverable.project_id.id != $route.params.projectId" class="task-exp">
						<span>
							<span class="icon close-collase">
								<i class="fas fa-plus"></i>
							</span>
						</span>
					</div>
					<div v-else class="task-exp">
						<span>
							<span class="icon close-collase text-danger">
								<i class="fas fa-minus"></i>
							</span>
						</span>
					</div>
				</div>
			</div>
			<div class="delv-block-resp">
			<!-- <DuplicateMediaCallBtn :deliverableId='deliverable.id' :namespace="namespace"  :deliverableTemplateId="deliverable.deliverable_template_id" /> -->
			<div class="d-flex flex-row dbox-wrapper">
				<div class="w-100 dbox-left-side">
					<div class="top-row">
						<div class="data-items text-primary">
							<span>
								{{ deliverableTypeTitle(deliverable.deliverable_template_id) }}
							</span>
						</div>
						<div class="data-items">
							<DeliverableProjects :deliverable="deliverable" :namespace="namespace" />
						</div>
						<!-- <div class="data-items dept">
							<DeliverableDepartments :deliverable="deliverable" :namespace="namespace" />
						</div> -->
						<div class="data-items">
							<span class="text-primary">PRIORITY: </span>
							<span v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(deliverable)" :class="'listing-priority-del-'+deliverable.id">
								<vue-star-rate
									:rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
									:maxIcon="5"
									:iconHeight="17"
									:iconWidth="17"
									:hasCounter="false"
									:key="'del-rating-'+Math.random()+deliverable.id"
									iconColor="var(--wf-primary)"
									iconColorHover="var(--wf-primary)"
									iconShape="circle"
								></vue-star-rate>
							</span>
						</div>
						<div class="data-items">
							<span class="text-primary">STARTED:</span>
							{{ deliverable.created_at | moment("DD MMM, YYYY @ H:mm") }}
						</div>
						<div v-if="deliverable.all_completed" class="data-items">
							<span class="text-primary">COMPLETED:</span>
							{{ deliverable.completed_at | moment("DD MMM, YYYY @ H:mm") }}
						</div>
						<div v-else class="data-items">
							<span class="text-primary">LAST MODIFIED:</span>
							{{ deliverable.updated_at | moment("DD MMM, YYYY @ H:mm") }}
						</div>
					</div>
					<DeliverableTypeIcon :deliverableTypeId="deliverable.deliverable_template_id" />
					<div class="row listing-row">
						<div class="col-md-8 titles breakpoint__fix">
							
							<!-- <div :title="deliverable.project_id == null || deliverable.project_id.id != $route.params.projectId ? 'Add to Project' : 'Remove from Project'" v-b-tooltip.hover class="link-deliverable-btn">
								<div @click="addToProject(deliverable.id)" v-if="deliverable.project_id == null || deliverable.project_id.id != $route.params.projectId" class="task-exp">
									<span>
										<span class="icon close-collase">
											<i class="fas fa-plus"></i>
										</span>
									</span>
								</div>
								<div @click="showRemoveProjectDeli=true; removingDeliverableId=deliverable.id" v-else class="task-exp">
									<span>
										<span class="icon close-collase text-danger">
											<i class="fas fa-minus"></i>
										</span>
									</span>
								</div>
							</div> -->

							<!-- <DeliverableTypeIcon :deliverableTypeId="deliverable.deliverable_template_id" /> -->
							<!-- <div v-b-tooltip.hover title="Priority" class="listing-priority" @click="setPriority(deliverable)" :class="'listing-priority-del-'+deliverable.id">
								<vue-star-rate
									:rateRange="deliverable.priority ? Number(deliverable.priority) : 0"
									:maxIcon="5"
									:iconHeight="17"
									:iconWidth="17"
									:hasCounter="false"
									:key="'del-rating-'+Math.random()+deliverable.id"
									iconColor="#4C9850"
									iconColorHover="#4C9850"
									iconShape="circle"
								></vue-star-rate>
							</div> -->
							<div class="inside-list department--wrap--new">
								<!-- <DeliverableProjects :deliverable="deliverable"  :namespace="namespace"/>
								<div class="deliverable-type-title">
									<span class="field-label">TYPE: </span>
									<span class="title">{{ deliverableTypeTitle(deliverable.deliverable_template_id) }}</span>
								</div> -->
								<DeliverableDepartments :deliverable="deliverable" :namespace="namespace" />
							</div>
							<!-- <div class="department-wrap">
								<div
								class="department-title"
								v-for="(department) in deliverable.departments"
								:key="'all-list-department-'+department.id"
								>
									{{ department.name }}
								</div>
							</div> -->
							<div
								class="deliverable-title edit-d-title"
								@click="showModalFn(deliverable.id)"
							>{{ deliverable.title }}</div>
						</div>
						<div v-if="!isMobile()" class="col-md-4 infos">
							<div class="d-flex flex-row">
								<DeliverableListCoordinators class="deliverable-list-coordinators" :deliverable="deliverable" />

								<DeliverableListContacts class="deliverable-list-contacts" :deliverable="deliverable" />

								<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable"  :namespace="namespace" />

								<!-- <TaskCompletionGraph class="ml-5" :deliverable="deliverable" /> -->
							</div>
						</div>
						<!-- <div class="col-md-2 breakpoint__fix" :class="'deliv-'+index">
							<DeliverableDatesRibbon :deliverable="deliverable" />
						</div> -->
					</div>
					<div class="row">
						<div class="col-md-12">
							<div>
								<b-collapse :visible="expandAll" :id="'task-listing-collapse-'+index">
									<div v-if="isMobile()" class="col-md-6 infos responsive-infos">
										<div class="d-flex flex-row">
											<DeliverableListCoordinators class="deliverable-list-coordinators" :deliverable="deliverable" />
											<DeliverableListContacts class="deliverable-list-contacts" :deliverable="deliverable" />
											<DeliverableListTags class="deliverable-list-tags" :deliverable="deliverable" :namespace="namespace" />
										</div>
									</div>
									<TaskFields :deliverable="deliverable" :deliverableId="deliverable.id" :myWeek="false" :tasks="deliverable.tasks" :users="deliverable.users" />
								</b-collapse>
							</div>
						</div>
					</div>
				</div>
				<div class="dbox-right-side">
					<CollapseTaskBtn :deliverable="deliverable" :index="index" :expandAll="expandAll" />
				</div>
			</div>

			</div>
			</div>
			<div class="pagination-wrapper" v-show="!myWeek">
				<pagination :data="allDeliverablesPaginationData" @pagination-change-page="onChangePage" :limit="5"></pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import EditModal from "./EditModal";
import TaskFields from "./TaskFields";
import CreateContactModal from "./CreateContactModal";
import UpdateContactModal from "./EditContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import UpdateSpokespersonModal from "./EditSpokespersonModal";
import CreateSpokespersonModal from "./CreateSpokespersonModal";
import vueStarRate from "vue-js-star-rating";

import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn";
// import DeliverablePriorityBadge from "../common/DeliverablePriorityBadge";

import UpdateWhoModal from "./EditWhoModal";
import CreateWhoModal from "./CreateWhoModal";


import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableListContacts from "./DeliverableListContacts";
import DeliverableListCoordinators from "./DeliverableListCoordinators";
import TaskCompletionGraph from "./TaskCompletionGraph";
import CollapseTaskBtn from "./CollapseTaskBtn";
import DeliverableTypeIcon from './DeliverableTypeIcon';
import DeliverableDatesRibbon from "./DeliverableDatesRibbon";
import toast from '../../toast';

export default {
	props: ["myWeek", "filterQuery", "expandAll", 'removedDeliverableId', "namespace"],
	data() {
		return {
			namespace:"",
			removingDeliverableId: false,
			showRemoveProjectDeli: false,
			activeView: '-1',
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			viewId: '',
		}
	},
	created() {
		//this.fetchDeliverables();
		// this.fetchContacts();
		this.fetchDepartments();
		this.fetchProjects();
		this.fetchViews();
		// this.fetchSubjects();
		this.fetchTags();
		this.fetchUsers();
		this.fetchGeoData();
		this.fetchAllCustomFields();
	},
	components: {
		EditModal,
		TaskFields,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		DuplicateMediaCallBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		ViewTitleModal,
		vueStarRate,
		DeliverableProjects,
		DeliverableTypeIcon
		// DeliverablePriorityBadge
	},
	computed: {
		...mapState({
			state (state) {
			  return state[this.namespace]
			},
			projectDetail (state, getters) {
			  return getters[this.namespace + 'projectDetail']
			},
			allDeliverables (state, getters) {
			  return getters[this.namespace + 'allDeliverables']
			},
			allDeliverablesPaginationData (state, getters) {
			  return getters[this.namespace + 'allDeliverablesPaginationData']
			},
			userDeliverablesPaginationData (state, getters) {
			  return getters[this.namespace + 'userDeliverablesPaginationData']
			},
			allTags (state, getters) {
			  return getters[this.namespace + 'allTags']
			},
			allContacts (state, getters) {
			  return getters[this.namespace + 'allContacts']
			},
			deliverableDetail (state, getters) {
			  return getters[this.namespace + 'deliverableDetail']
			},
			allDepartments (state, getters) {
			  return getters[this.namespace + 'allDepartments']
			},
			allSubjects (state, getters) {
			  return getters[this.namespace + 'allSubjects']
			},
			userDeliverables (state, getters) {
			  return getters[this.namespace + 'userDeliverables']
			},
			unGroupedUserDeliverables (state, getters) {
			  return getters[this.namespace + 'unGroupedUserDeliverables']
			},
			deliverableFilter (state, getters) {
			  return getters[this.namespace + 'deliverableFilter']
			},
			myWeekDeliverableFilter (state, getters) {
			  return getters[this.namespace + 'myWeekDeliverableFilter']
			},
			outletCount (state, getters) {
			  return getters[this.namespace + 'outletCount']
			},
			userAbilities (state, getters) {
			  return getters['userAbilities']
			},
			userViews (state, getters) {
			  return getters[this.namespace + 'userViews']
			},
			deliverableTypes (state, getters) {
			  return getters[this.namespace + 'deliverableTypes']
			},
			editDeliverableModal (state, getters) {
			  return getters[this.namespace + 'editDeliverableModal']
			},
			addContactModal (state, getters) {
			  return getters[this.namespace + 'addContactModal']
			},
			editContactModal (state, getters) {
			  return getters[this.namespace + 'editContactModal']
			},
			editSpokespersonModal (state, getters) {
			  return getters[this.namespace + 'editSpokespersonModal']
			},
			editWhoModal (state, getters) {
			  return getters[this.namespace + 'editWhoModal']
			},
		}),
		deliverableListIcon() {
			if(this.deliverableFilter.deliverableType && typeof(this.deliverableFilter.deliverableType[0]) == 'undefined') {
				if(typeof this.deliverableFilter.deliverableType.id != 'undefined' && this.deliverableFilter.deliverableType.id != 'all') {
					return this.deliverableFilter.deliverableType.id.replaceAll('_', '-');
				} else {
					return 'media-call';
				}
			} else {
				return 'media-call';
			}
		},
		deliverablesArray() {
			if(this.myWeek) {
				return this.userDeliverables
			} else {
				return this.allDeliverables;
			}
		},
		_() {
			return _;
		}
	},
	methods: {
		...mapActions([
			"getProjectDetail",
			"fetchDeliverables",
			"createTag",
			"fetchUsers",
			"fetchContacts",
			"updateFieldValue",
			"fetchDepartments",
			"fetchSubjects",
			"fetchTags",
			"fetchGeoData",
			"fetchAllCustomFields",
			"filterDeliverables",
			'fetchViews',
			'fetchProjects',
			'addDeliverableToProject'
		]),
		onConfirmRemoveProjectDeli() {
			let that = this;
			if(this.removingDeliverableId) {
				this.$store
					.dispatch(this.namespace + "removeProjectDeliverable", { projectId: this.projectDetail.id, deliverableId: this.removingDeliverableId })
					.then(() => {
						that.$store.dispatch(that.namespace + 'fetchProjectDeliverable').then(function(response) {
							that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable removed from project.');
							that.$store.commit(this.namespace + "setProjectDetail", response.data.projectDetail);
							let x = 0;
							console.log('1', that.allDeliverables)
							if (typeof that.allDeliverables != "undefined") {
								console.log('2', that.allDeliverables)
								for (x = 0; x < Object.keys(that.allDeliverables).length; x++) {
									console.log('3', that.allDeliverables, that.allDeliverables[x].id, that.removingDeliverableId)
									if (typeof that.allDeliverables[x] != 'undefined' && that.allDeliverables[x].id == that.removingDeliverableId) {
										that.allDeliverables[x].project_id = null
									}
								}
							}
							// that.$store.dispatch(that.namespace + "fetchDeliverables");
						});
					});
			}
		},
		addToProject(deliverableId) {
			let projectId = this.$route.params.projectId;
			let that = this;
			this.addDeliverableToProject({projectId, deliverableId}).then(function(resp) {
				let x = 0;
				if (typeof that.allDeliverables != "undefined") {
					for (x = 0; x < Object.keys(that.allDeliverables).length; x++) {
						if (typeof that.allDeliverables[x] != 'undefined' && that.allDeliverables[x].id == deliverableId) {
							that.allDeliverables[x].project_id = {id: projectId, name: resp.projectDetail.title}
						}
					}
				}
				// that.$store.dispatch(that.namespace + "fetchDeliverables");
			})
		},
		deliverableTypeTitle(deliverableTypeId) {
			if(this.deliverableTypes) {
				let typeData = _.filter(this.deliverableTypes, {typeId: deliverableTypeId});
				if(typeData.length > 0) {
					return typeData[0].name;
				}
			}
		},
		handleResetFilter() {
			$('.viewmenu-dropdown').removeClass('show');
			this.$root.$emit('resetFilter')
		},
		updatePerfectScroll() {
			let self = this;
			setTimeout(function() {
				if(typeof self.$refs.views__scroll != 'undefined') {
					self.$refs.views__scroll.update();
				}
			}, 1);
		},
		setActiveView() {
			if(this.$router.currentRoute.name == 'dashboard') {
				if(localStorage.getItem('dashboardActiveSave')) {
					this.activeView = localStorage.getItem('dashboardActiveSave');
					this.viewBtnLabel = localStorage.getItem('dashboardActiveSaveTitle');
					this.currentViewData = localStorage.getItem('dashboardActiveSaveData');
					this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if(this.$router.currentRoute.name == 'myWeek') {
				if(localStorage.getItem('myWeekActiveSave')) {
					this.activeView = localStorage.getItem('myWeekActiveSave');
					this.viewBtnLabel = localStorage.getItem('myWeekActiveSaveTitle');
					this.currentViewData = localStorage.getItem('myWeekActiveSaveData');
					this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			}
		},
		removeView(viewId) {
			if(this.$router.currentRoute.name == 'dashboard') {
				if(viewId == localStorage.getItem('dashboardActiveSave')) {
					this.resetView();
				}
			} else if(this.$router.currentRoute.name == 'myWeek') {
				if(viewId == localStorage.getItem('myWeekActiveSave')) {
					this.resetView();
				}
			}
			this.$store.dispatch(this.namespace + 'removeView', viewId);
		},
		resetView() {
			localStorage.removeItem("dashboardActiveSave");
			localStorage.removeItem("myWeekActiveSave");
			localStorage.removeItem("dashboardActiveSaveTitle");
			localStorage.removeItem("myWeekActiveSaveTitle");
			this.setActiveView();
		},
		loadView(viewData) {
			this.currentViewData = JSON.parse(viewData.saved_data);
			let index = viewData.id;
			this.showUpdateView = true;
			this.viewBtnLabel = viewData.title;
			if(this.$router.currentRoute.name == 'dashboard') {
				this.activeView = index;
				localStorage.setItem('dashboardActiveSave', index);
				localStorage.setItem('dashboardActiveSaveTitle', viewData.title);
				localStorage.setItem('dashboardActiveSaveData', viewData.saved_data);
			} else if(this.$router.currentRoute.name == 'myWeek') {
				this.activeView = index;
				localStorage.setItem('myWeekActiveSave', index);
				localStorage.setItem('myWeekActiveSaveTitle', viewData.title);
				localStorage.setItem('myWeekActiveSaveData', viewData.saved_data);
			}
			if(this.$router.currentRoute.name == 'dashboard') {
				this.$store.commit(this.namespace + 'setDashboardDeliverableFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.deliverableFilter);
				// this.filterQuery = this.deliverableFilter;
			} else if(this.$router.currentRoute.name == 'myWeek') {
				this.$store.commit(this.namespace + 'setMyWeekDeliverableFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.myWeekDeliverableFilter);
				// this.filterQuery = this.myWeekDeliverableFilter;
			}
		},
		saveView() {
			this.$bvModal.show("viewTitleModal");
		},
		directUpdateView() {
			this.showUpdateViewText = false;
			let view = "";
			if (this.$router.currentRoute.name == "dashboard") {
				view = this.deliverableFilter;
			} else if (this.$router.currentRoute.name == "myWeek") {
				view = this.myWeekDeliverableFilter;
			}
			let viewData = {
					title: this.viewBtnLabel,
					filterQuery: view,
					viewId: this.activeView
				};
			let that = this;
			this.$store.dispatch(this.namespace + "saveView", viewData).then(function() {
				if(that.$router.currentRoute.name == 'dashboard') {
					localStorage.setItem('dashboardActiveSaveData', JSON.stringify(view));
				} else if(that.$router.currentRoute.name == 'myWeek') {
					localStorage.setItem('myWeekActiveSaveData', JSON.stringify(view));
				}
				that.setActiveView();
				toast.info('View has been saved.');
			});
		},
		updateView() {
			this.$bvModal.show("viewTitleUpdateModal");
		},
		setPriority(deliverable) {
			let priority = $('.listing-priority-del-'+deliverable.id+' .vue-star-rate ul.list li.active').length;
			let priorityData = {
				field_id: 23,
				parentId: null,
				value: priority,
				deliverable_id: deliverable.id,
				id: deliverable.id
			};
			this.updateFieldValue(priorityData);
		},
		editDeliverableModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		hasMyWeek() {
			if (this.userDeliverables) {
				if (this.userDeliverables.overdue.length > 0 ||
				this.userDeliverables.today.length > 0 ||
				this.userDeliverables.thisWeek.length > 0 ||
				this.userDeliverables.nextWeek.length > 0 ||
				this.userDeliverables.upcoming.length > 0 ||
				this.userDeliverables.noDeadline.length > 0
				// || this.userDeliverables.completed.length > 0
				) {
					return true;
				}
			}
			return false;
		}
		,
		createNewDeliverable() {
			let type = 'media_call';
			if(this.deliverableFilter.deliverableType && typeof(this.deliverableFilter.deliverableType[0]) == 'undefined') {
				type = this.deliverableFilter.deliverableType.id;
			} 
			this.$store
				.dispatch(this.namespace + "createNewDeliverable", { type })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show("editDeliverableModal");
					this.$nextTick(() => {
						$('.edit-deliverable-modal .deliverable-title').trigger('click');
					})
					this.$store.dispatch(this.namespace + "fetchDeliverables")
				});
		},
		focusContactModal() {
			this.$refs.refContactModal.focusMyElement();
		},
		focusUpdateContactModal() {
			this.$refs.refUpdateContactModal.focusMyElement();
		},
		focusSpokespersonModal() {
			this.$refs.refSpokespersonModal.focusMyElement();
		},
		focusUpdateSpokespersonModal() {
			this.$refs.refUpdateSpokespersonModal.focusMyElement();
		},
		focusWhoModal() {
			this.$refs.refWhoModal.focusMyElement();
		},
		focusUpdateWhoModal() {
			this.$refs.refUpdateWhoModal.focusMyElement();
		},
		onChangePage(data) {
			this.fetchDeliverables(data);
		},

		showModalFn(deliverableId) {
			// shows edit deliverable modal
			this.$store
				.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show("editDeliverableModal");
				});
			//this.$store.commit(this.namespace + "toggleEditDeliverableModal");
		},

		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
				history.pushState(
					{},
					null,
					'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
				this.$router.push({name: 'dashboard'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
				//this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
			}
		}
	},
	beforeUpdate() {
		if(this.activeView != '-1') {
			$('.views__scroll > div').removeClass('scroll__view__btns');
			$('.update-view').removeClass('d-none');			
		} else {
			$('.views__scroll > div').addClass('scroll__view__btns');
			$('.update-view').addClass('d-none');
		}
		if(!$('.deliverable-listing').hasClass('hasFilter')) {
			$('.save-view').addClass('d-none');
			$('.update-view').addClass('d-none');
			this.showUpdateViewText = false;
			$('.views__scroll > div').addClass('scroll__view__btns');
			this.showCreateNewView = false;
		} else {
			$('.save-view').removeClass('d-none');
			
			if(this.activeView == '-1') {
				this.showCreateNewView = true;
			} else {
				this.showCreateNewView = false;
			}
		}
		if($('.save-view').hasClass('d-none') && $('.update-view').hasClass('d-none')) {
			$('.views__scroll > div').addClass('scroll__view__btns');
		} else {
			$('.views__scroll > div').removeClass('scroll__view__btns');
		}
	},
	mounted() {
		let that = this;
		this.getProjectDetail({projectId: this.$route.params.projectId});
		this.$root.$on('updateListTitle', function(title) {
			console.log('title=', title);
			that.listTitle = title;
			console.log('that.listTitle=', that.listTitle);
		});
		this.setActiveView();

		this.$root.$on('hideUpdateText', function() {
			that.showUpdateViewText = false;
		});
		this.$root.$on('resetView', function() {
			that.resetView();
		});
		let tempJson3 = false;
		this.$root.$on('showUpdateViewText', function(currentFilter) {
			if(that.$router.currentRoute.name != 'myWeek' && that.$router.currentRoute.name != 'dashboard') return;

			
			let excludedKeys = ['myWeek'];
			let tempJson1 = currentFilter;


			let tempJson2 = that.activeView != '-1' ? that.currentViewData : false;
			if(typeof tempJson2 == 'string') {
				tempJson2 = JSON.parse(that.currentViewData);
			}

			that.showUpdateViewText = false;
			if(tempJson2) {
				Object.entries(currentFilter).forEach(([key, value]) => {
					if(typeof tempJson2[key] != 'undefined' 
						&& excludedKeys.indexOf(key) == -1) {
						if(key == 'dateRange' || key == 'dateCreatedRange' || key == 'dateCompletedRange') {
							let tempDateFlags = {
								dateRange: 'filterByDate',
								dateCreatedRange: 'filterByDateCreated',
								dateCompletedRange: 'filterByDateCompleted'
							};
							if(tempJson2[tempDateFlags[key]]) {
								let temp1StartDate = (typeof tempJson1[key].startDate != 'string') ? tempJson1[key].startDate.toISOString() : tempJson1[key].startDate,
									temp1EndDate = (typeof tempJson1[key].endDate != 'string') ? tempJson1[key].endDate.toISOString() : tempJson1[key].endDate,
									temp2StartDate = (typeof tempJson2[key].startDate != 'string') ? tempJson2[key].startDate.toISOString() : tempJson2[key].startDate,
									temp2EndDate = (typeof tempJson2[key].endDate != 'string') ? tempJson2[key].endDate.toISOString() : tempJson2[key].endDate;
								if((temp1StartDate.substr(0, 10) != temp2StartDate.substr(0, 10)) && temp1EndDate.substr(0, 10) != temp2EndDate.substr(0, 10)) {
									that.showUpdateViewText = true;
									return;
								}
							}
						} else {
							if(JSON.stringify(tempJson1[key]) != JSON.stringify(tempJson2[key])) {
								that.showUpdateViewText = true;
								return;
							}
						}
					} 
				});
			}
		});
		
		Echo.channel('deliverable').listen('DeliverableUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {
					if (this.allDeliverables[x].id == e.deliverable.deliverableId) {
						this.$store.commit(this.namespace + "setDeliverable", e.deliverable);
						this.$store.commit(this.namespace + "setDeliverableDetail", e.deliverable);
					}
				}
			}
		});
		Echo.channel('deliverable').listen('DeliverableContactsUpdated', (e) => {
			let userId = localStorage.getItem("userId");
				if (userId != e.user.id) {
					this.$store.commit(this.namespace + "setDeliverableContacts", {contacts:e.contacts, deliverableId: e.deliverableId});
				}
		});
		Echo.channel('task').listen('TaskUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				let xx = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {

					if (this.allDeliverables[x].id == e.deliverableId) {
						// ok, lets update the task now for that deliverable..
						for (xx = 0; xx < this.allDeliverables[x].tasks.length; xx++) {
							if (this.allDeliverables[x].tasks[xx].taskId == e.task.taskId) {
								this.$store.commit(this.namespace + "setTask", {task:e.task, deliverableId: e.deliverableId});
								}
						}
					}
				}
			}
		});

		this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverables.editDeliverableModal = false;
				let currentTitle = document.title.match(/\(\d+\)\s/g);
        		if(!currentTitle) {
					document.title = process.env.MIX_APP_NAME;
				} else {
					document.title = currentTitle[0] + process.env.MIX_APP_NAME;
				}
			}
		});
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editDeliverableModal") {
				this.$store.state.deliverables.editDeliverableModal = true;
			}
		});

		if(this.$router.currentRoute.path.indexOf('/deliverable/') != -1) {
			let deliverableId = this.$router.currentRoute.path.split('/')[2],
				that = this;
			this.$store.dispatch(this.namespace + 'getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
				that.$bvModal.show('editDeliverableModal');
			});
		}
	},
	watch: {
		'removedDeliverableId': function(to, from) {
			if(to) {
				let x = 0;
				if (typeof this.allDeliverables != "undefined") {
					for (x = 0; x < Object.keys(this.allDeliverables).length; x++) {
						if (typeof this.allDeliverables[x] != 'undefined' && this.allDeliverables[x].id == to) {
							this.allDeliverables[x].project_id = null
						}
					}
				}
			}
		},
		'$route': function(to, from) {
			if(to.path.indexOf('deliverable/') != -1) {
				let deliverableId = to.path.split('/')[2],
					that = this;
				this.$store.dispatch(this.namespace + 'getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
					that.$bvModal.show('editDeliverableModal');
				});
			}
		},
	}
};
</script>